import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-toolbar.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSToolbarContainer = props => {
  const {
    id,
    className,
    children,
    style,
    tag = 'div',
    ...attributes
  } = props;
  // Renders the custom Tag
  const ToolbarHeaderTag = tag || 'div';
  const containerClassName = getClassNameList('uitk-toolbar', className);
  return jsx(ToolbarHeaderTag, {
    id: id,
    className: containerClassName,
    style: style,
    ...attributes,
    children: children
  });
};
EGDSToolbarContainer.displayName = 'EGDSToolbarContainer';
export { EGDSToolbarContainer };